import { useState } from 'react';
import { Button, Modal } from '@skupreme/shared/ui';
import { LoaderBar } from '@components/LoaderBar';
import { ToastMessage } from '@utility/toast';
import BatchOrdersService from '@utility/services/batch-order';
import { useOrdersV2 } from '@features/orders/hooks/orders-v2';

type ConfirmFulfillPopupProps = {
  open: boolean;
  closeModal: () => void;
  batchToFulfill?: { _id?: string; name?: string } | null;
};

export function ConfirmFulfillPopup({
  open,
  closeModal,
  batchToFulfill,
}: ConfirmFulfillPopupProps) {
  const [saving, setSaving] = useState(false);
  /* EN-4117: fulfilling a batch answers with a Firebase key; V2 has no such path. */
  const { isV2 } = useOrdersV2();
  const onSubmit = async () => {
    try {
      setSaving(true);
      const res = await BatchOrdersService.fulfill(batchToFulfill?._id);
      if (res.firebase_key) {
        ToastMessage.success(
          'Batch Fulfillment Initiated Successfully, Please check back later for updates.',
        );
        closeModal();
      } else {
        ToastMessage.error('Failed to initiate fulfillment. Please try again.');
      }
    } catch (error) {
      ToastMessage.apiError(error);
    } finally {
      setSaving(false);
    }
  };

  if (isV2) {
    return null;
  }

  return (
    <Modal
      isOpen={open}
      onOpenChange={isOpen => !isOpen && closeModal()}
      title="Confirm Fulfill"
      size="sm"
      showCloseButton
      bodyClassName="sk:relative"
      footer={
        <>
          <Button variant="pill" onPress={closeModal}>
            Cancel
          </Button>
          <Button variant="primary" onPress={onSubmit} isDisabled={saving}>
            Confirm
          </Button>
        </>
      }
    >
      {saving && <LoaderBar content="Saving" />}
      <p className="sk:m-0">
        Are you sure to fulfill the batch{' '}
        <span className="sk:font-semibold">{batchToFulfill?.name}</span>
      </p>
    </Modal>
  );
}
